import * as proto from 'src/proto/compiled-protos';
import { Observable, map } from "rxjs";
import { IndeterminatePaginatorData } from "src/app/general/components/indeterminate-paginator/indeterminate-paginator-model";
import { OrdersModel } from "./orders-model";
import { BackendService } from "../../services/backend.service";
import { DataTableColumn, StringColumn } from "src/app/general/components/data-table/data-table-column";
import { Formatter } from "../../util/formatter";

export class OrdersForLaterModel implements OrdersModel {
  backendService: BackendService;

  constructor(
      backendService: BackendService) {
    this.backendService = backendService;
  }

  fetchData(continuationToken: string | null | undefined): Observable<IndeterminatePaginatorData<proto.waiternow.common.IOrderProto>> {
    return this.backendService.findOrdersForLaterReturnObservable(continuationToken)
      .pipe(
        map(oreders => {
          const paginatorData: IndeterminatePaginatorData<proto.waiternow.common.IOrderProto> = {data: [], continuationToken: continuationToken};
          if (oreders) {
            paginatorData.data = oreders.orders;
            paginatorData.continuationToken = oreders.continuationToken;
          }
          return paginatorData;
        })
      );
  }

  getAdditionalColumns(): Array<DataTableColumn<proto.waiternow.common.IOrderProto>> {
    return [
      new StringColumn(
        /* name= */ 'timeToPrepare',
        /* translateId= */ 'time_to_prepare',
        /* valueExtractor= */ order =>
          Formatter.formatTimestampProto(order.timeToPrepare),
        /* hideInCompactMode= */ true
      ),
      new StringColumn(
        /* name= */ 'location',
        /* translateId= */ 'location',
        /* valueExtractor= */ order => order.redundantData?.businessName + ' ' + order.redundantData?.locationName,
        /* hideInCompactMode= */ true
      )
    ];
  }
}
